var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.mostrarComponente()
    ? _c(
        "b-container",
        [
          _vm.mostrarAlertaSemaforo
            ? _c("div", { staticClass: "alerta-semaforo-derecha" }, [
                _c(
                  "button",
                  {
                    staticClass: "cerrar-alerta-semaforo",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.mostrarAlertaSemaforo = false
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _vm._v(" "),
                _c("strong", [_vm._v("Validación requerida")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n      " + _vm._s(_vm.mensajeAlertaSemaforo) + "\n    "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h4", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.$t("bandeja.estimación")),
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-badge",
                    {
                      attrs: {
                        variant: "primary",
                        href: _vm.solicitud.SOLICITUD_RIZOMA.documentoPu
                          .documento.uri,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("bandeja.verPu")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-badge",
                    {
                      attrs: {
                        variant: "primary",
                        href: _vm.solicitud.SOLICITUD_RIZOMA.documentoSolicitud
                          .documento.uri,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("bandeja.verSolicitud")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.solicitud.reconsideracion &&
                  _vm.solicitud.reconsideracion.uri
                    ? _c(
                        "b-badge",
                        {
                          attrs: {
                            variant: "primary",
                            href: _vm.solicitud.reconsideracion.uri,
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("bandeja.verReconsideracion")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.revisorSeleccionado
            ? _c(
                "b-row",
                { staticClass: "text-right" },
                [
                  _c("b-col", { attrs: { md: "12" } }, [
                    _c("h5", [
                      _vm._v(
                        "Se seleccionó Evaluador " +
                          _vm._s(_vm.revisorSeleccionado)
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "mt-3", attrs: { md: "12" } }, [
                _c("div", { staticClass: "alerta-evaluacion-2026" }, [
                  _c("div", { staticClass: "icono-alerta-evaluacion" }, [
                    _vm._v("i"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "texto-alerta-evaluacion" }, [
                    _c("div", [
                      _vm._v(
                        "\n            La rúbrica de evaluación se compone de la valoración cuantitativa (serie de actividades para cada uno de los componentes) y la\n            valoración cualitativa, donde usted realizará la selección de una opción en la escala de valoración de las cualidades\n            definidas por componente.\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            Podrá realizar la valoración cualitativa únicamente en dos ocasiones, por lo que se le solicita que antes del guardado revise\n            puntualmente sus respuestas\n          "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _vm.segundaOportunidadActiva &&
                  !_vm.evaluacionGuardada2 &&
                  !_vm.evaluacionGuardadaFinal
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "aviso-segunda-oportunidad-tabla",
                          attrs: { show: "", variant: "warning" },
                        },
                        [
                          _vm._v(
                            "\n        Tiene una segunda oportunidad adicional para evaluar.\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "tablaValoracionCualitativa",
                      staticClass: "contenedor-tabla-valoracion",
                      class: {
                        "resaltar-segunda-oportunidad":
                          _vm.resaltarTablaSegundaOportunidad,
                        "evaluacion-bloqueada": _vm.tablaCualitativaBloqueada,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tabla-evaluacion-2026",
                          class: {
                            "tabla-cualitativa-bloqueada":
                              _vm.tablaCualitativaBloqueada,
                          },
                        },
                        [
                          _c("div", { staticClass: "bloque-componente" }, [
                            _c("div", { staticClass: "titulo-componente" }, [
                              _vm._v("Componente 1. "),
                              _c("strong", [
                                _vm._v(
                                  "Producción científica, humanística o tecnológica"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "encabezado-componente" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "columna-actividades-header" },
                                  [_vm._v("Actividades")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "columna-cualidades-header" },
                                  [_vm._v("Cualidades")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "contenido-componente" }, [
                              _c(
                                "div",
                                { staticClass: "columna-actividades" },
                                [
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [_vm._v(" Artículos ")]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.totalArticulos ?? 0)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c(
                                      "span",
                                      [
                                        _vm._v(
                                          "\n                    Libros\n\n                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icono-tooltip",
                                            attrs: { id: "tooltip-libros" },
                                          },
                                          [_vm._v("i")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tooltip",
                                          {
                                            attrs: {
                                              target: "tooltip-libros",
                                              triggers: "hover focus",
                                              placement: "right",
                                              "custom-class":
                                                "tooltip-evaluacion",
                                              variant: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Registros como autor principal o co-autor.\n                      "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                      Un producto registrado como libro, será contabilizado con el mismo valor que cuatro artículos.\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.totalProductoAutorPrincipalCoAutor ??
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c(
                                      "span",
                                      [
                                        _vm._v(
                                          "\n                    Capítulos\n\n                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icono-tooltip",
                                            attrs: { id: "tooltip-capitulos" },
                                          },
                                          [_vm._v("i")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tooltip",
                                          {
                                            attrs: {
                                              target: "tooltip-capitulos",
                                              triggers: "hover focus",
                                              placement: "right",
                                              "custom-class":
                                                "tooltip-evaluacion",
                                              variant: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Registros como autor principal o de correspondencia o co-autor.\n                      "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                      Los textos registrados como capítulos de un libro, serán considerados con el mismo valor que un artículo.\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.totalProductoAutorCorrespondenciaPrincipal
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [_vm._v("Reportes ")]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.totalReportes ?? 0)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [_vm._v("Informes ")]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.totalInformes ?? 0)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [
                                      _vm._v("Dossier o número temático "),
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.totalDossier ?? 0)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [_vm._v("Antologías ")]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.totalAntologias ?? 0)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [
                                      _vm._v("Traducciones de obras "),
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.totalTraducciones ?? 0)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [
                                      _vm._v(
                                        "Prólogos y estudios introductorios "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.totalPrologoEstudioIntroductorio ??
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [_vm._v("Datos primarios ")]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.totalBaseDatosPrimarios ?? 0)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [_vm._v("Curaduría ")]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.totalCuraduria ?? 0)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c("span", [
                                      _vm._v(
                                        " Desarrollo tecnológico o innovación "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.totalDesarrolloTecno ?? 0)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c(
                                      "span",
                                      [
                                        _vm._v(
                                          "\n                    Propiedad intelectual\n\n                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icono-tooltip",
                                            attrs: {
                                              id: "tooltip-propiedad-intelectual",
                                            },
                                          },
                                          [_vm._v("i")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tooltip",
                                          {
                                            attrs: {
                                              target:
                                                "tooltip-propiedad-intelectual",
                                              triggers: "hover focus",
                                              placement: "right",
                                              "custom-class":
                                                "tooltip-evaluacion",
                                              variant: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Registros de Propiedad intelectual otorgada.\n                      "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                      Los productos registrados como derecho de propiedad intelectual otorgado serán equivalentes a cuatro artículos.\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.totalProductoPropiedadIntelectualOtorgada ??
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fila-actividad" }, [
                                    _c(
                                      "span",
                                      [
                                        _vm._v(
                                          "Transferencias tecnológicas\n                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icono-tooltip",
                                            attrs: {
                                              id: "tooltip-transferencia-tecnologica",
                                            },
                                          },
                                          [_vm._v("i")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tooltip",
                                          {
                                            attrs: {
                                              target:
                                                "tooltip-transferencia-tecnologica",
                                              triggers: "hover focus",
                                              placement: "right",
                                              "custom-class":
                                                "tooltip-evaluacion",
                                              variant: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Los productos registrados como transferencia tecnológica, serán equivalentes a cuatro artículos.\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.totalTransferenciatecno ?? 0)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "fila-actividad fila-total",
                                    },
                                    [
                                      _c("span", [_vm._v("Total")]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.totalProductosComponente1)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "columna-cualidades" }, [
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [_vm._v("Relevante")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                      Cuando es una contribución original que aporta al avance de la investigación científica, humanística o tecnológica.\n                    "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: { name: "relevante" },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .relevante,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "relevante",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.relevante",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "relevante"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .relevante &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .relevante.text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(opcion.text) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [_vm._v("Pertinente")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                      Cuando la producción está vinculada con necesidades sociales, ambientales o tecnológicas, o bien, amplía las\n                      fronteras del conocimiento en un área específica.\n                    "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: { name: "pertinente" },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .pertinente,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "pertinente",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.pertinente",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "pertinente"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .pertinente &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .pertinente.text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(opcion.text) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [_vm._v("Sostenida")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                      Cuando la producción que realiza a lo largo del tiempo muestra consolidación en las líneas de investigación y,\n                      eventualmente, se desarrollan nuevas líneas de investigación como parte de la trayectoria.\n                    "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: { name: "sostenida" },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .sostenida,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "sostenida",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.sostenida",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "sostenida"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .sostenida &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .sostenida.text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(opcion.text) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [_vm._v("Diversa")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                      Cuando la persona investigadora tiene la capacidad de difundir sus conocimientos mediante diferentes tipos de\n                      productos.\n                    "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: { name: "diversa" },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .diversa,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "diversa",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.diversa",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "diversa"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .diversa &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .diversa.text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(opcion.text) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bloque-componente componente-2" },
                        [
                          _c("div", { staticClass: "titulo-componente" }, [
                            _vm._v("Componente 2. "),
                            _c("strong", [
                              _vm._v(
                                "Fortalecimiento y consolidación de la comunidad"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "encabezado-componente" }, [
                            _c(
                              "div",
                              { staticClass: "columna-actividades-header" },
                              [_vm._v("Actividades")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "columna-cualidades-header" },
                              [_vm._v("Cualidades")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "contenido-componente" }, [
                            _c("div", { staticClass: "columna-actividades" }, [
                              _c("div", { staticClass: "fila-actividad" }, [
                                _c(
                                  "span",
                                  [
                                    _vm._v(
                                      "\n                  Docencia\n\n                  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "icono-tooltip",
                                        attrs: { id: "tooltip-docencia" },
                                      },
                                      [_vm._v(" i ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          target: "tooltip-docencia",
                                          triggers: "hover focus",
                                          placement: "right",
                                          variant: "danger",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Registros de los últimos 5 años (2021-2026).\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.totalProductoDocenciaCincoAnios)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fila-actividad" }, [
                                _c("span", [
                                  _vm._v("Desarrollo institucional"),
                                ]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.totalDesarrolloInstitucional)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fila-actividad" }, [
                                _c(
                                  "span",
                                  [
                                    _vm._v(
                                      "\n                  Trabajos de titulación\n\n                  "
                                    ),
                                    _vm.solicitudRizomaActual.nivelAspira.id ===
                                      "3" ||
                                    _vm.solicitudRizomaActual.nivelAspira.id ===
                                      "4"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "icono-tooltip",
                                            attrs: {
                                              id: "tooltip-trabajos-titulacion",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    i\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.solicitudRizomaActual.nivelAspira.id ===
                                      "3" ||
                                    _vm.solicitudRizomaActual.nivelAspira.id ===
                                      "4"
                                      ? _c(
                                          "b-tooltip",
                                          {
                                            attrs: {
                                              target:
                                                "tooltip-trabajos-titulacion",
                                              triggers: "hover focus",
                                              placement: "right",
                                              variant: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Registros como director o co-director.\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.solicitudRizomaActual.nivelAspira.id ===
                                  "1" ||
                                _vm.solicitudRizomaActual.nivelAspira.id === "2"
                                  ? _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.totaltrabajosTitulacion)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.solicitudRizomaActual.nivelAspira.id ===
                                  "3" ||
                                _vm.solicitudRizomaActual.nivelAspira.id === "4"
                                  ? _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.totalProductoDirectorCoDirector
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fila-actividad" }, [
                                _c(
                                  "span",
                                  [
                                    _vm._v("Otros\n                  "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "icono-tooltip",
                                        attrs: { id: "tooltip-Otros" },
                                      },
                                      [_vm._v(" i ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          target: "tooltip-Otros",
                                          triggers: "hover focus",
                                          placement: "right",
                                          variant: "danger",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Evaluaciones realizadas, Participación en Jurado, Evaluación de Programas, Dictaminación de Publicaciones,\n                    Dictaminación Especializada, Estancias de investigación, Trabajo Editorial\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("strong", [_vm._v(_vm._s(_vm.totalOtros))]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "fila-actividad fila-total" },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(
                                        "\n                  Total\n\n                  "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icono-tooltip",
                                          attrs: {
                                            id: "tooltip-total-componente-2",
                                          },
                                        },
                                        [_vm._v(" i ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tooltip",
                                        {
                                          attrs: {
                                            target:
                                              "tooltip-total-componente-2",
                                            triggers: "hover focus",
                                            placement: "right",
                                            variant: "danger",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Respetar las reglas de los rubros obligatorios*\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.totalProductosComponente2) +
                                        "\n                "
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "columna-cualidades cualidades-componente-2",
                              },
                              [
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [
                                      _vm._v("Comprometido con la formación"),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                    Cuando se desarrollan actividades de docencia o acompañamiento en la obtención de grado o en la tutoría de estancias y\n                    proyectos de investigación de estudiantes de nivel medio superior, licenciatura, maestría, doctorado o aquellas\n                    vinculadas con estancias posdoctorales.\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: {
                                            name: "comprometidoFormacion",
                                          },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .comprometidoFormacion,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "comprometidoFormacion",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.comprometidoFormacion",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "comprometidoFormacion"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .comprometidoFormacion &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .comprometidoFormacion
                                                        .text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(opcion.text) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [_vm._v("Colaborativo")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                    Cuando se implementan acciones que fomenten la vinculación entre estudiantes (vocaciones científicas) y personas\n                    investigadoras.\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: { name: "colaborativo" },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .colaborativo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "colaborativo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.colaborativo",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "colaborativo"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .colaborativo &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .colaborativo.text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(opcion.text) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [_vm._v("Constante")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "Cuando se realizan las actividades de forma continua a lo largo de su trayectoria."
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: { name: "constante" },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .constante,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "constante",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.constante",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "constante"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .constante &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .constante.text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(opcion.text) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bloque-componente componente-3" },
                        [
                          _c("div", { staticClass: "titulo-componente" }, [
                            _vm._v("Componente 3. "),
                            _c("strong", [_vm._v("Divulgación")]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "encabezado-componente" }, [
                            _c(
                              "div",
                              { staticClass: "columna-actividades-header" },
                              [_vm._v("Actividades")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "columna-cualidades-header" },
                              [_vm._v("Cualidades")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "contenido-componente" }, [
                            _c("div", { staticClass: "columna-actividades" }, [
                              _c("div", { staticClass: "fila-actividad" }, [
                                _c(
                                  "span",
                                  [
                                    _vm._v("Divulgación\n                  "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "icono-tooltip",
                                        attrs: { id: "tooltip-Divulgacion" },
                                      },
                                      [_vm._v(" i ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          target: "tooltip-Divulgacion",
                                          triggers: "hover focus",
                                          placement: "right",
                                          variant: "danger",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Se contabiliza toda la sección de Divulgación\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.totalAccesoUniversal)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "fila-actividad fila-total" },
                                [
                                  _c("span", [_vm._v("Total")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        Number(_vm.totalAccesoUniversal || 0)
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "columna-cualidades cualidades-componente-3",
                              },
                              [
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [
                                      _vm._v("Inclusiva y gratuita"),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                    Cuando las actividades están dirigidas a la población tomando en cuenta su diversidad según edad, sexo, lengua,\n                    discapacidad (física, sensorial, intelectual y psicosocial) o etnia. La población podrá acceder al conocimiento sin\n                    pagar por ello.\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: { name: "inclusivaGratuita" },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .inclusivaGratuita,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "inclusivaGratuita",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.inclusivaGratuita",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "inclusivaGratuita"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .inclusivaGratuita &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .inclusivaGratuita
                                                        .text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(opcion.text) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "bloque-cualidad" }, [
                                  _c("div", { staticClass: "texto-cualidad" }, [
                                    _c("strong", [_vm._v("Comprensible")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                    Cuando el medio de comunicación se caracteriza por utilizar un lenguaje e imagen clara que facilite la interpretación\n                    y pueda ser asimilado de forma sencilla, que permita la reflexión y apropiación del conocimiento.\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "escala-cualidad" },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          staticClass: "grupo-semaforo",
                                          attrs: { name: "comprensible" },
                                          model: {
                                            value:
                                              _vm.valoracionesCualitativas
                                                .comprensible,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.valoracionesCualitativas,
                                                "comprensible",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "valoracionesCualitativas.comprensible",
                                          },
                                        },
                                        _vm._l(
                                          _vm.opcionesValoracionCualitativaPorCampo(
                                            "comprensible"
                                          ),
                                          function (opcion) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: opcion.text,
                                                staticClass: "opcion-semaforo",
                                                class: [
                                                  opcion.clase,
                                                  {
                                                    seleccionada:
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .comprensible &&
                                                      _vm
                                                        .valoracionesCualitativas
                                                        .comprensible.text ===
                                                        opcion.value.text,
                                                  },
                                                ],
                                                attrs: {
                                                  value: opcion.value,
                                                  disabled: opcion.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(opcion.text) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "div",
                    { staticClass: "bloque-resultado-evaluacion" },
                    [
                      _c("label", { staticClass: "titulo-nivel-sugerido" }, [
                        _vm._v(
                          "\n          Nivel sugerido con base en los rangos cuantitativos y la valoración cualitativa seleccionada:\n\n          "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.right",
                                value: {
                                  title:
                                    "Se está considerando la trayectoria de investigación",
                                  variant: "danger",
                                },
                                expression:
                                  "{\n              title: 'Se está considerando la trayectoria de investigación',\n              variant: 'danger',\n            }",
                                modifiers: { hover: true, right: true },
                              },
                            ],
                            staticClass: "icono-tooltip",
                            attrs: {
                              id: "tooltip-nivel-sugerido-rangos-cualitativa",
                            },
                          },
                          [_vm._v("\n            i\n          ")]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.evaluacion1.id && !_vm.segundaOportunidadActiva
                        ? _c(
                            "b-alert",
                            {
                              staticClass:
                                "text-center font-weight-bold nivel-calculado",
                              attrs: { show: "", variant: "warning" },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.evaluacion1.nombre) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm.evaluacion2.id &&
                          _vm.segundaOportunidadActiva &&
                          !_vm.evaluacion3.id
                        ? _c(
                            "b-alert",
                            {
                              staticClass:
                                "text-center font-weight-bold nivel-calculado",
                              attrs: { show: "", variant: "warning" },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.evaluacion2.nombre) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm.evaluacion3.id && _vm.segundaOportunidadActiva
                        ? _c(
                            "b-alert",
                            {
                              staticClass:
                                "text-center font-weight-bold nivel-calculado",
                              attrs: { show: "", variant: "warning" },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.evaluacion3.nombre) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _c("b-alert", {
                            staticClass:
                              "text-center font-weight-bold nivel-calculado",
                            attrs: { show: "", variant: "warning" },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.evaluacionIndividual
                    ? _c("div", [
                        _c("label", { staticClass: "titulo-nivel-sugerido" }, [
                          _vm._v(" Prelación: " + _vm._s(_vm.resumen) + " "),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    { attrs: { show: _vm.validaNiveles, variant: "warning" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("evaluacion-individual.nivelNoRepetido")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "bloque-resultado-evaluacion" }, [
                  _c("div", { staticClass: "nivel-sugerido-bloque" }, [
                    _vm.mostrarTextos()
                      ? _c(
                          "div",
                          { staticClass: "descripcion-nivel-sugerido" },
                          [
                            ["a_1", "d_1"].includes(
                              _vm.claveDescripcionNivelSugerido
                            )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar investigación en ciencia básica y de frontera,\n                actividades enfocadas en la atención de problemas nacionales, participe en la articulación de propuestas y soluciones con\n                diversos sectores de la sociedad.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 2 (dos) elementos de fortalecimiento y consolidación de la comunidad, particularmente\n                una de docencia en el período inmediato anterior; y al menos 2 (dos) elementos de acceso universal al conocimiento y sus\n                beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : ["a_2", "d_2"].includes(
                                  _vm.claveDescripcionNivelSugerido
                                )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida investigación en ciencia básica y\n                de frontera, así como actividades enfocadas en la atención de problemas nacionales, promueva la articulación de propuestas\n                y soluciones con diversos sectores de la sociedad.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 5 (cinco) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente una de docencia en el período inmediato anterior, una actividad\n                de participación de trabajos de titulación y una actividad de desarrollo institucional; y al menos 4 (cuatro) elementos de\n                acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : ["a_3", "d_3"].includes(
                                  _vm.claveDescripcionNivelSugerido
                                )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida, relevante y pertinente\n                investigación en ciencia básica y de frontera, así como actividades enfocadas en la atención de problemas nacionales;\n                cuente con un reconocido liderazgo nacional por sus aportaciones al avance del estado del conocimiento en uno o más campos\n                específicos o por el impacto de sus aportaciones a la solución de problemas que por su importancia y gravedad requiera una\n                atención integral, profunda y amplia, generando redes de colaboración para la articulación de propuestas y soluciones con\n                diversos sectores de la sociedad o con diversas instituciones de educación superior o centros de investigación del país.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 7 (siete) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente una de docencia a nivel licenciatura en el periodo inmediato\n                anterior, una actividad de participación en dirección o co-dirección de trabajos de titulación y una actividad de\n                desarrollo institucional; y al menos 6 (seis) elementos de acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : ["a_4", "d_4"].includes(
                                  _vm.claveDescripcionNivelSugerido
                                )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida, relevante y pertinente\n                investigación en ciencia básica y de frontera, así como actividades enfocada en la atención de problemas nacionales, posea\n                un reconocido liderazgo nacional e internacional por la trascendencia de su obra en el avance del estado del conocimiento\n                en uno o más campos específicos e impacto de sus aportaciones a la solución de problemas que por su importancia y gravedad\n                requiera una atención integral, profunda y amplia; asimismo gestione redes de colaboración para la articulación de\n                propuestas y soluciones con diversos sectores de la sociedad; así como una activa participación en el desarrollo\n                institucional y destacada labor en la formación de la comunidad humanística, científica, tecnológica o de innovación del\n                país y actividades de acceso universal al conocimiento en temas relacionados a su campo de especialidad.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 8 (ocho) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente dos de docencia, una de ellas a nivel licenciatura en el período\n                inmediato anterior, dos actividades de participación en dirección o co-dirección de trabajos de titulación y una actividad\n                de desarrollo institucional; y al menos 8 (ocho) elementos de acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : ["a_5", "d_5"].includes(
                                  _vm.claveDescripcionNivelSugerido
                                )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "No se cumplen con los criterios de evaluación necesarios para obtener o renovar el reconocimiento en el SNII."
                                    ),
                                  ]),
                                ])
                              : _vm.claveDescripcionNivelSugerido === "c_1"
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre la capacidad para realizar desarrollo de tecnologías estratégicas de\n                vanguardia o innovación abierta para la transformación social, así como el acompañamiento de talento especializado y\n                desarrollo de actividades de acceso universal al conocimiento.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 2 (dos) elementos de fortalecimiento y consolidación de la comunidad, particularmente\n                una de docencia en el período inmediato anterior; y al menos 2 (dos) elementos de acceso universal al conocimiento y sus\n                beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : _vm.claveDescripcionNivelSugerido === "c_2"
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida desarrollo de tecnologías\n                estratégicas de vanguardia o innovación abierta para la transformación social, o para incidir en la atención de problemas\n                nacionales, así como la formación de la comunidad humanística, científica, tecnológica o de innovación del país, además,\n                el desarrollo de actividades de acceso universal al conocimiento en temas relacionados a su campo de especialidad.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 5 (cinco) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente una de docencia en el período inmediato anterior, una actividad\n                de participación de trabajos de titulación y una actividad de desarrollo institucional; y al menos 4 (cuatro) elementos de\n                acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : _vm.claveDescripcionNivelSugerido === "c_3"
                              ? _c(
                                  "div",
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida, relevante y pertinente el\n                desarrollo de tecnologías estratégicas de vanguardia o innovación abierta para la transformación social, o para incidir en\n                la atención de problemas nacionales y posea un reconocido liderazgo nacional, así como la formación de la comunidad\n                humanística, científica, tecnológica o de innovación del país, desarrollo de actividades de acceso universal al\n                conocimiento en temas relacionados a su campo de especialidad y haber colaborado en la transferencia de tecnología con\n                diversas instituciones u organizaciones del país.\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("P", [
                                      _vm._v(
                                        "\n                Asimismo, deberá acreditar al menos 7 (siete) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente una de docencia a nivel licenciatura en el periodo inmediato\n                anterior, una actividad de participación en dirección o co-dirección de trabajos de titulación y una actividad de\n                desarrollo institucional; y al menos 6 (seis) elementos de acceso universal al conocimiento y sus beneficios sociales.\n              "
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm.claveDescripcionNivelSugerido === "c_4"
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida, relevante y pertinente el\n                desarrollo de tecnologías estratégicas de vanguardia o innovación abierta para la transformación social, o para incidir en\n                la atención de problemas nacionales y posea un reconocido liderazgo nacional e internacional, así como la formación de la\n                comunidad humanística, científica, tecnológica o de innovación del país, desarrollo de actividades de acceso universal al\n                conocimiento en temas relacionados a su campo de especialidad y haber colaborado en la transferencia de tecnología con\n                diversas instituciones u organizaciones del país.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 8 (ocho) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente dos de docencia, una de ellas a nivel licenciatura en el período\n                inmediato anterior, dos actividades de participación en dirección o co-dirección de trabajos de titulación y una actividad\n                de desarrollo institucional; y al menos 8 (ocho) elementos de acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : _vm.claveDescripcionNivelSugerido === "c_5"
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "No se cumplen con los criterios de evaluación necesarios para obtener o renovar el reconocimiento en el SNII."
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "confirmacion-nivel" }, [
                  _vm.mostrarBotonesConfirmacion()
                    ? _c("label", { staticClass: "pregunta-confirmacion" }, [
                        _vm._v(
                          "\n          ¿Confirma el nivel sugerido?\n\n          "
                        ),
                        !_vm.evaluacionGuardada2
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.right",
                                    value: {
                                      title:
                                        "En caso de que el nivel sugerido no se adapte a su recomendación, podrá realizar una vez más la valoración cualitativa.",
                                      variant: "danger",
                                    },
                                    expression:
                                      "{\n              title:\n                'En caso de que el nivel sugerido no se adapte a su recomendación, podrá realizar una vez más la valoración cualitativa.',\n              variant: 'danger',\n            }",
                                    modifiers: { hover: true, right: true },
                                  },
                                ],
                                staticClass: "icono-tooltip",
                              },
                              [_vm._v("\n            i\n          ")]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mostrarBotonNoAprobado
                    ? _c("label", { staticClass: "pregunta-confirmacion" }, [
                        _vm._v(
                          '\n          En caso de considerar que la persona solicitante no cumple con los Criterios Específicos de Evaluación para obtener o renovar el\n          reconocimiento en el SNII, presione el botón "No Aprobar".\n        '
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mostrarBotonNoAprobado
                    ? _c(
                        "label",
                        { staticClass: "pregunta-confirmacion" },
                        [
                          _vm.mostrarBotonNoAprobado
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.guardarNivelNoAprobado()
                                    },
                                  },
                                },
                                [_vm._v(" No Aprobar ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mostrarBotonExcepcion
                    ? _c("label", { staticClass: "pregunta-confirmacion" }, [
                        _vm._v(
                          '\n          En caso de considerar como excepción la trayectoria notable, una vez valorada de manera cuantitativa y cualitativa, la persona\n          solicitante amerite ser considerada para un nivel superior, presione el botón "Excepción".\n        '
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "botones-confirmacion" },
                    [
                      _vm.evaluacion2?.id === "4" &&
                      !_vm.evaluacionGuardadaFinal
                        ? _c(
                            "b-button",
                            {
                              staticClass:
                                "btn-confirmacion btn-confirmacion-guinda",
                              class: {
                                activo: _vm.confirmaNivelSugerido === "SI",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmarNivelSugerido("SI")
                                },
                              },
                            },
                            [_vm._v("\n            Guardar\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mostrarBotonesConfirmacion()
                        ? _c(
                            "b-button",
                            {
                              staticClass:
                                "btn-confirmacion btn-confirmacion-guinda",
                              class: {
                                activo: _vm.confirmaNivelSugerido === "SI",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmarNivelSugerido("SI")
                                },
                              },
                            },
                            [_vm._v("\n            Sí\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mostrarBotonesConfirmacion()
                        ? _c(
                            "b-button",
                            {
                              staticClass:
                                "btn-confirmacion btn-confirmacion-guinda",
                              class: {
                                activo: _vm.confirmaNivelSugerido === "NO",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmarNivelSugerido("NO")
                                },
                              },
                            },
                            [_vm._v("\n            No\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mostrarBotonExcepcion
                        ? _c(
                            "b-button",
                            {
                              staticClass:
                                "btn-confirmacion btn-confirmacion-guinda",
                              on: {
                                click: function ($event) {
                                  return _vm.mostrarExcepcion()
                                },
                              },
                            },
                            [_vm._v("\n            Excepción\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mostrarFormularioExcepcion &&
                      !_vm.evaluacionGuardadaFinal
                        ? _c(
                            "div",
                            { staticClass: "bloque-excepcion" },
                            [
                              _c(
                                "div",
                                { staticClass: "alerta-excepcion" },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "info-circle" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                De conformidad con el artículo 12 de los Criterios Específicos de Evaluación se considera recomendar lo siguiente:\n              "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    show: _vm.tieneCandidato,
                                    variant: "warning",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("bandeja.tieneCandidato2026")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("label", [_vm._v("Nivel por excepción")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.nivelExcepcionSeleccionado,
                                      expression: "nivelExcepcionSeleccionado",
                                    },
                                  ],
                                  staticClass:
                                    "form-control nivel-excepcion-select",
                                  attrs: {
                                    disabled: _vm.evaluacionGuardadaFinal,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.nivelExcepcionSeleccionado = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: { disabled: "" },
                                      domProps: { value: null },
                                    },
                                    [_vm._v("Seleccione un nivel")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.nivelesExcepcionDisponibles,
                                    function (item, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: item },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item.nombre) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mostrarFormularioExcepcion &&
                      _vm.evaluacionGuardadaFinal
                        ? _c(
                            "div",
                            { staticClass: "bloque-excepcion" },
                            [
                              _c(
                                "div",
                                { staticClass: "alerta-excepcion" },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "info-circle" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                De conformidad con el artículo 12 de los Criterios Específicos de Evaluación se considera recomendar lo siguiente:\n              "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-alert",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    show: _vm.tieneCandidato,
                                    variant: "warning",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("bandeja.tieneCandidato2026")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("label", [_vm._v("Nivel por excepción")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.nivelExcepcionSeleccionado,
                                      expression: "nivelExcepcionSeleccionado",
                                    },
                                  ],
                                  staticClass:
                                    "form-control nivel-excepcion-select",
                                  attrs: {
                                    disabled: _vm.evaluacionGuardadaFinal,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.nivelExcepcionSeleccionado = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: { disabled: "" },
                                      domProps: { value: null },
                                    },
                                    [_vm._v("Seleccione un nivel")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.nivelesExcepcionDisponibles,
                                    function (item, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: item },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item.nombre) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "bloque-resultado-evaluacion" }, [
                  _c("div", { staticClass: "nivel-sugerido-bloque" }, [
                    _vm.mostrarFormularioExcepcion &&
                    _vm.nivelExcepcionSeleccionado
                      ? _c(
                          "div",
                          { staticClass: "descripcion-nivel-sugerido" },
                          [
                            ["a_1", "d_1"].includes(
                              _vm.claveDescripcionNivelSugerido
                            )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar investigación en ciencia básica y de frontera,\n                actividades enfocadas en la atención de problemas nacionales, participe en la articulación de propuestas y soluciones con\n                diversos sectores de la sociedad.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 2 (dos) elementos de fortalecimiento y consolidación de la comunidad, particularmente\n                una de docencia en el período inmediato anterior; y al menos 2 (dos) elementos de acceso universal al conocimiento y sus\n                beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : ["a_2", "d_2"].includes(
                                  _vm.claveDescripcionNivelSugerido
                                )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida investigación en ciencia básica y\n                de frontera, así como actividades enfocadas en la atención de problemas nacionales, promueva la articulación de propuestas\n                y soluciones con diversos sectores de la sociedad.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 5 (cinco) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente una de docencia en el período inmediato anterior, una actividad\n                de participación de trabajos de titulación y una actividad de desarrollo institucional; y al menos 4 (cuatro) elementos de\n                acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : ["a_3", "d_3"].includes(
                                  _vm.claveDescripcionNivelSugerido
                                )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida, relevante y pertinente\n                investigación en ciencia básica y de frontera, así como actividades enfocadas en la atención de problemas nacionales;\n                cuente con un reconocido liderazgo nacional por sus aportaciones al avance del estado del conocimiento en uno o más campos\n                específicos o por el impacto de sus aportaciones a la solución de problemas que por su importancia y gravedad requiera una\n                atención integral, profunda y amplia, generando redes de colaboración para la articulación de propuestas y soluciones con\n                diversos sectores de la sociedad o con diversas instituciones de educación superior o centros de investigación del país.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 7 (siete) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente una de docencia a nivel licenciatura en el periodo inmediato\n                anterior, una actividad de participación en dirección o co-dirección de trabajos de titulación y una actividad de\n                desarrollo institucional; y al menos 6 (seis) elementos de acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : ["a_4", "d_4"].includes(
                                  _vm.claveDescripcionNivelSugerido
                                )
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida, relevante y pertinente\n                investigación en ciencia básica y de frontera, así como actividades enfocada en la atención de problemas nacionales, posea\n                un reconocido liderazgo nacional e internacional por la trascendencia de su obra en el avance del estado del conocimiento\n                en uno o más campos específicos e impacto de sus aportaciones a la solución de problemas que por su importancia y gravedad\n                requiera una atención integral, profunda y amplia; asimismo gestione redes de colaboración para la articulación de\n                propuestas y soluciones con diversos sectores de la sociedad; así como una activa participación en el desarrollo\n                institucional y destacada labor en la formación de la comunidad humanística, científica, tecnológica o de innovación del\n                país y actividades de acceso universal al conocimiento en temas relacionados a su campo de especialidad.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 8 (ocho) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente dos de docencia, una de ellas a nivel licenciatura en el período\n                inmediato anterior, dos actividades de participación en dirección o co-dirección de trabajos de titulación y una actividad\n                de desarrollo institucional; y al menos 8 (ocho) elementos de acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : _vm.claveDescripcionNivelSugerido === "c_1"
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre la capacidad para realizar desarrollo de tecnologías estratégicas de\n                vanguardia o innovación abierta para la transformación social, así como el acompañamiento de talento especializado y\n                desarrollo de actividades de acceso universal al conocimiento.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 2 (dos) elementos de fortalecimiento y consolidación de la comunidad, particularmente\n                una de docencia en el período inmediato anterior; y al menos 2 (dos) elementos de acceso universal al conocimiento y sus\n                beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : _vm.claveDescripcionNivelSugerido === "c_2"
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida desarrollo de tecnologías\n                estratégicas de vanguardia o innovación abierta para la transformación social, o para incidir en la atención de problemas\n                nacionales, así como la formación de la comunidad humanística, científica, tecnológica o de innovación del país, además,\n                el desarrollo de actividades de acceso universal al conocimiento en temas relacionados a su campo de especialidad.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 5 (cinco) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente una de docencia en el período inmediato anterior, una actividad\n                de participación de trabajos de titulación y una actividad de desarrollo institucional; y al menos 4 (cuatro) elementos de\n                acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : _vm.claveDescripcionNivelSugerido === "c_3"
                              ? _c(
                                  "div",
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida, relevante y pertinente el\n                desarrollo de tecnologías estratégicas de vanguardia o innovación abierta para la transformación social, o para incidir en\n                la atención de problemas nacionales y posea un reconocido liderazgo nacional, así como la formación de la comunidad\n                humanística, científica, tecnológica o de innovación del país, desarrollo de actividades de acceso universal al\n                conocimiento en temas relacionados a su campo de especialidad y haber colaborado en la transferencia de tecnología con\n                diversas instituciones u organizaciones del país.\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("P", [
                                      _vm._v(
                                        "\n                Asimismo, deberá acreditar al menos 7 (siete) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente una de docencia a nivel licenciatura en el periodo inmediato\n                anterior, una actividad de participación en dirección o co-dirección de trabajos de titulación y una actividad de\n                desarrollo institucional; y al menos 6 (seis) elementos de acceso universal al conocimiento y sus beneficios sociales.\n              "
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm.claveDescripcionNivelSugerido === "c_4"
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "\n                Podrá recibir la distinción quien demuestre capacidad para realizar de manera sostenida, relevante y pertinente el\n                desarrollo de tecnologías estratégicas de vanguardia o innovación abierta para la transformación social, o para incidir en\n                la atención de problemas nacionales y posea un reconocido liderazgo nacional e internacional, así como la formación de la\n                comunidad humanística, científica, tecnológica o de innovación del país, desarrollo de actividades de acceso universal al\n                conocimiento en temas relacionados a su campo de especialidad y haber colaborado en la transferencia de tecnología con\n                diversas instituciones u organizaciones del país.\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                Asimismo, deberá acreditar al menos 8 (ocho) elementos de fortalecimiento y consolidación de la comunidad humanística,\n                científica, tecnológica y de innovación, particularmente dos de docencia, una de ellas a nivel licenciatura en el período\n                inmediato anterior, dos actividades de participación en dirección o co-dirección de trabajos de titulación y una actividad\n                de desarrollo institucional; y al menos 8 (ocho) elementos de acceso universal al conocimiento y sus beneficios sociales.\n              "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.evaluacionGuardadaFinal
                    ? _c(
                        "b-alert",
                        {
                          staticClass:
                            "text-center font-weight-bold nivel-calculado",
                          attrs: { show: "", variant: "warning" },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                'Diríjase al menú lateral izquierdo al apartado "Dictamen" para continuar con el proceso de evaluación.'
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }